import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Account, SignUpAccount } from '../../shared/model/authentication/account.model';
import { AppState } from '../../store/app.state';
import { ActionsSubject, Store } from '@ngrx/store';
import { LOG_OUT, SIGN_IN_ERROR, SIGN_IN_SUCCESS, SignIn, SignInSuccess } from '../../store/authentication/auth.action';
import { Observable, Subscription } from 'rxjs';
import { AuthenticationService } from '../../shared/service/auth/authentication.service';
import { ModelStore } from '../../shared/model.store';

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss']
})
export class AuthenticationComponent implements OnInit{

  store_id: any;

  @Input()
  controlAuthClass: any;

  @Output()
  hideAuthForm = new EventEmitter<any>();

  authSubc: Subscription;
  authState: Observable<any>;

  // login, sign-up, forgot-pwd
  activeTab: any;

  loginError = false;

  phoneError = false;
  emailError = false;
  signUpSuccessful = false;

  EMAIL_ERROR_CODE = -14;
  PHONE_ERROR_CODE = -21;

  forgotAccount: any;
  forgotPwdSuccessful = false;
  isReadPolicy = false;
  isReadTerm = false;
  isAgreeTerm = false;
  isSubmitted = false;
  account: Account = new Account();
  signUpAccount: SignUpAccount = new SignUpAccount();
  dispensaryName = 'this dispensary';

  constructor(private store: Store<AppState>,
    private actionsSubj: ActionsSubject,
    private authenticationService: AuthenticationService,
    private modelStore: ModelStore){}

  ngOnInit() {
    this.modelStore.dispensaryObservable.subscribe(dispensary => {
      this.dispensaryName = dispensary['disp_name'];
    });
    this.authState = this.store.select('authentication');
    this.authSubc = this.actionsSubj.subscribe(data => {
      if (data.type === LOG_OUT) {
        this.hideAuthForm.emit();
      } else if (data.type === SIGN_IN_SUCCESS) {
        this.hideAuthForm.emit();
        window.scrollTo(0, 0);
      } else if (data.type === SIGN_IN_ERROR) {
        this.loginError = true;
        this.controlAuthClass = '';
      }
    });
    this.initData();
    this.signUpAccount.deal_alerts = 0;
  }

  initData() {
    this.account = new Account();
    this.signUpAccount = new SignUpAccount();
    this.activeTab = 'login';
    this.loginError = false;
    this.phoneError = false;
    this.signUpSuccessful = false;
    this.forgotAccount = '';
    this.forgotPwdSuccessful = false;
  }

  swapTab(tabId) {
    if (!this.signUpSuccessful) {
      this.activeTab = tabId;
    }
  }

  close() {
    this.hideAuthForm.emit();
    this.isReadTerm = false;
    this.isReadPolicy = false;
  }

  isInvalidAccount() {
    return this.authenticationService.isInvalidAccount(this.account);
  }

  signIn() {
    // this.reservationState = this.store.select('reservation');
    if (this.signUpSuccessful) {
      this.hideAuthForm.emit();
      return;
    }
    if (this.isInvalidAccount()) {
      this.loginError = true;
      return;
    }
    this.store.dispatch(new SignIn(this.account));
  }

  isInvalidSignUpAccount() {
    return !this.isAgreeTerm || this.authenticationService.isInvalidSignUpAccount(this.signUpAccount);
  }

  signUp() {
    this.isSubmitted = true;
    this.signUpSuccessful = false;
    this.authenticationService.signUp(this.signUpAccount).subscribe(rs => {
      if (rs && rs['profile']) {
        this.account.account = this.signUpAccount.email;
        this.account.password = this.signUpAccount.password;
        this.phoneError = false;
        this.signUpSuccessful = true;
        const signInData = { access_token: rs['profile'].access_token, profile: rs['profile'] };
        this.store.dispatch(new SignInSuccess(signInData));
      } else if (rs && rs['code'] === this.PHONE_ERROR_CODE){
          this.phoneError = true;
      } else if (rs && rs['code'] === this.EMAIL_ERROR_CODE){
          this.emailError = true;
      }
    });
  }

  isInvalidForgotAccount() {
    return this.authenticationService.isInvalidForgotAccount(this.forgotAccount);
  }

  forgotPwd() {
    this.forgotPwdSuccessful = false;
    if (this.isInvalidForgotAccount()) {
      return;
    }
    this.authenticationService.forgotPwd(this.forgotAccount).subscribe(rs => {
      if (rs && rs['code'] === 0) {
        this.forgotPwdSuccessful = true;
      }
    });
  }

  readTerms() {
    (window as any).open("https://www.leafbuyer.com/termsofuse", "_blank");
  }

  readPolicy() {
    (window as any).open("https://www.leafbuyer.com/privacypolicy", "_blank");
  }

  backToSignUp() {
    this.isReadTerm = false;
    this.isReadPolicy = false;
  }

  checkSendEmail(event) {
    this.signUpAccount.deal_alerts = event.target.checked ? 1 : 0;
  }
}


